/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FaqSection } from '../../models';

@Component({
  selector: 'ut-academy-faq',
  templateUrl: './academy-faq.component.html',
  styleUrls: ['./academy-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class AcademyFaqComponent {
  @Input() sections: FaqSection[] = [];

  private openFaqKey: string | null = null;

  toggleFaq(key: string): void {
    this.openFaqKey = this.openFaqKey === key ? null : key;
  }

  isFaqOpen(key: string): boolean {
    return this.openFaqKey === key;
  }

  faqKey(sectionIndex: number, itemIndex: number): string {
    return `${sectionIndex}-${itemIndex}`;
  }
}
